import type { Dispatch } from 'vuex';
import eventBus, { EVENTS } from '../eventBus';
import type { SearchState } from '../model/searchState';

export async function doCleanSearch(
  searchState: SearchState,
  dispatch: Dispatch,
  payload: string
) {
  searchState.ops.setSearchString(payload);

  await dispatch('clearAllFilters', { root: true });
  eventBus.emit(EVENTS.DO_SEARCH);
}


